import React from 'react'

export interface DropdownSelectContextValue {
  multi?: boolean
  draggable?: boolean
  selectedItems?: string[]
  partiallySelectedItems?: Set<string>
  onItemSelect?: (itemId: string) => void
  onItemToggle?: (itemId: string, checked: boolean) => void
  showTooltips?: boolean
}

export const DropdownSelectContext = React.createContext<DropdownSelectContextValue | null>(null)
